"use client";
import type { FC, ReactNode } from "react";
import { headingSizeMap, mapSizesTitle } from "../../content/page-heading/mapSizes";
import { Text } from "../../content/text/Text";
import { Box } from "../../layout/box/Box";
import { Flex } from "../../layout/flex/Flex";
import { styles } from "./StoryGridStyles";

export interface IStoryGridProps {
    title: string;
    titleSize: string;
    description: string;
    tileCount: number;
    children: ReactNode;
    textColor?: string;
}

export const StoryGrid: FC<IStoryGridProps> = ({
    title,
    titleSize,
    description,
    tileCount,
    children,
    textColor = "black",
}) => {
    const isGridLayout = tileCount === 2 || tileCount === 3;
    const resolvedTitleSize = titleSize in mapSizesTitle ? titleSize : "large";

    return (
        <Box {...styles.root}>
            {(title || description) && (
                <Flex
                    {...styles.header}
                    {...(isGridLayout ? styles.headerGridLayout : styles.headerDefault)}
                >
                    {title && (
                        <Box
                            as={headingSizeMap[resolvedTitleSize]}
                            fontSize={mapSizesTitle[resolvedTitleSize]}
                            aria-label={title}
                            {...styles.title}
                            color={textColor}
                        >
                            {title}
                        </Box>
                    )}
                    {description && (
                        <Text {...styles.description} color={textColor}>
                            {description}
                        </Text>
                    )}
                </Flex>
            )}
            <Box
                __css={styles.tiles}
                gridTemplateColumns={{ xl: `repeat(${tileCount}, minmax(0, 1fr))` }}
            >
                {children}
            </Box>
        </Box>
    );
};
